/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    bindQuoteVariation,
    checkSoftReferral,
    postSoftReferral,
    removeSoftReferral,
    renewalReferralReasons,
    renewalBindQuoteVariation,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import BindContainer from '../components/BindContainer'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        step05: state.step05,
        softReferrals: state.step05.softReferrals,
        quoteId: props.quoteId,
        varId: props.varId,
        postSoftRef: state.step05.postSoftRef,
    }
}

export default connect(
    mapStateToProps,
    {
        bindQuoteVariation: bindQuoteVariation,
        checkSoftReferral: checkSoftReferral,
        postSoftReferral: postSoftReferral,
        removeSoftReferral: removeSoftReferral,
        renewalReferralReasons: renewalReferralReasons,
        renewalBindQuoteVariation: renewalBindQuoteVariation,

    }
)(BindContainer)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/containers/BindContainer.tsx